import { render, staticRenderFns } from "./ResetPasswordRequested.vue?vue&type=template&id=0dedd238&lang=pug&"
import script from "./ResetPasswordRequested.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordRequested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports